function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_edit");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon_edit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-1",
  stroke: "#061A32",
  points: "22.8990749 0.707080008 9.5381937 14.0679627 7.8877315 19.0193461 12.9177103 17.3688851 26.1999989 4.00800368"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.538208,14.0678711 L12.9177253,17.3687947",
  id: "Stroke-2",
  stroke: "#061A32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.698486,2.9077148 L24.0780033,6.2086384",
  id: "Stroke-3",
  stroke: "#061A32"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-4",
  stroke: "#061A32",
  points: "15.4327497 2.82919932 0.5 2.82919932 0.5 26.4072262 24.078026 26.4072262 24.078026 9.90260602"
}), /*#__PURE__*/React.createElement("path", {
  d: "",
  id: "Stroke-5",
  strokeOpacity: 0.69803923,
  stroke: "#061A32"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-6",
  strokeOpacity: 0.69803923,
  stroke: "#061A32",
  points: "8.4379139 17.7618144 9.0666609 18.5477484 8.0449467 18.7835314"
}));

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit.1375a2c5.svg";
export { ForwardRef as ReactComponent };